module.exports = __webpack_public_path__ + "img/7.6efeebf0.webp";